import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const GET_REPORT_USERS_ACTION = createAsyncThunk('/get_report', async () => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_REPORT_USERS);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const GET_BY_ID_REPORT_USERS_ACTION = createAsyncThunk('/get_by_id_report', async (id) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_BY_ID_REPORT_USERS, {
      params: {
        user_id: id
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});